import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Doctor } from '@app/_models';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DoctorService {
    constructor(
        private http: HttpClient
    ) {
    }
    getAll() {
        
        return this.http.get<any>(`${environment.apiUrl}personnels/doctors`);
    }
    getById(id: string) {
        return this.http.get<Doctor>(`${environment.apiUrl}/personnels/doctors/${id}`);
    }
}